module.exports = __webpack_public_path__ + "static/media/map_pin_icon.1eeca72a.svg";